<template>
  <segments-chart :title="title" :items="formattedItems">
    <template #top-controls-extra>
      <div class="buttons-select">
        <buttons-select
          :choices="buttonChoices"
          v-model="value" />
      </div>
    </template>
  </segments-chart>
</template>

<script>
import getNested from 'lodash-es/get';
import SegmentsChart from '@/components/widgets/SegmentsChart';
import ButtonsSelect from '@/components/widgets/ButtonsSelect';
import isEmpty from 'lodash-es/isEmpty';

export default {
  name: 'congestion-segments-chart',

  components: {
    ButtonsSelect,
    SegmentsChart,
  },

  props: {
    title: {
      type: String,
      default: 'No title specified',
    },

    items: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      buttonChoices: [
        {value: 'count', text: 'Count'},
        {value: 'dwt', text: 'DWT'},
      ],
      value: 'count',
    };
  },

  computed: {
    formattedItems() {
      if(isEmpty(this.items)) {
        return [];
      }

      let counter = 0;
      return this.items.map(item => {
        let segmentName = getNested(item, 'item', null);
        if(!segmentName) {
          segmentName = `Unknown (${++counter})`;
        }
        return {
          segment: segmentName,
          volume: getNested(item, this.value, 0),
        }
      });
    },
  },
}
</script>

<style scoped>
.buttons-select {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.buttons-select >>> .choice-buttons {
  margin: 0 2px 0 0;
}

</style>